<div *ngIf="!freemium">
  <div class="row no-gutters pt-3 pb-5">
      <div class="w-100 card">
        <div class="card-header">
          <h5 class="pl-3">Project's setup</h5>
        </div>
        <div class="card-body">
          <div class="sp-project-setup">
            <div [ngClass]="{'sp-project-setup-analysis': options.showPresetSelection}" class=" sp-project-setup-analysis">
              <mat-form-field appearance="outline" class="w-100  sp-form-field">
                <mat-label class="sp-input-label">
                  <span>Project Name</span>
                </mat-label>
                <input #projectNameInput (change)="onProjectNameChange(projectNameInput.value)" [formControl]="projectNameControl" class="sp-input-content"  matInput maxlength="25" placeholder="Type project's name..."/>
                <span class="sp-information-tooltip sp-transform-icon" matSuffix matTooltip="To create you project, please define the name of it." matTooltipHideDelay="10" style="transform: translateY(-3px)">
                    <span class="">i</span>
                 </span>
                <mat-error *ngIf="projectNameControl.hasError('required')">
                  Please specify a <strong>project name</strong> to launch your project
                </mat-error>
              </mat-form-field>
              <span class="float-right">{{projectNameInput.value.length}} / 25</span>
            </div>
            <div #audienceLibrary  *ngIf="options.showPresetSelection" class="sp-project-setup-preset" style="position: relative;">

              <span  class="flex flex-row items-center gap-16 audience-input-container">
                <mat-form-field (click)="showAudienceLibrary = !showAudienceLibrary" appearance="outline" class="w-100 sp-form-field">
                  <mat-label class="sp-input-label">
                    <span>Audiences Definition Library</span>
                  </mat-label>
                  <mat-select class="sp-input-content" panelClass="sp-select-option-icon" placeholder="{{selectedAudience ? selectedAudience.name : 'Select an Audience Definition...' }}"></mat-select>
                  <span class="material-symbols-outlined"  matSuffix matTooltip="Select an audience definition from the Audience Library based on your analysis goals. You can use it as-is or modify it in the 'Audience's Interest' section." matTooltipHideDelay="10" style="width: 20px;height: 20px;margin-right: 10px;color: #EF8251;cursor: help">
                  info
                </span>
                </mat-form-field>
                <span (click)="resetAudiencePreset()" class="color-error-600 font-medium text-base2 cursor-pointer" [ngClass]="selectedAudience ? 'color-error-600' : 'color-disabled-400 cursor-initial'">Clear</span>
              </span>
              <div class="flex flex-col border-radius-8 bg-color-white-900" style="position: absolute;
                z-index: 10;
                width: calc(100% - 65px);
                box-shadow: 0px 7.796px 18.711px 0px rgba(92, 152, 248, 0.15);
                ">
              
                <div [style.display]="showAudienceLibrary ? 'block' : 'none'">
                  <div class="px-12 py-16">
                    <app-titan-input (onChange)="onTreeSearch($event)" [icon]="'search'"></app-titan-input>
                  </div>
                  
                  <div class="flex flex-row gap-22" style="height: 200px;" style="padding-left: 12px;padding-right: 16px; padding-bottom: 24px;">
                    <div class="flex flex-row" style="position: relative;">
                      <div class="flex flex-col pl-12 gap-12" style="width: 178px;">
                        <div *ngFor="let root of rootElements" 
                             (click)="onLeftSideNodeClick(root)" 
                             class="border-radius-top-left border-radius-bottom-left border-right-2 py-10 pl-16 pr-24 cursor-pointer" 
                             [ngClass]="isNodeTheSelectedLeftSideNode(root) ? 'bg-color-black-100 border-orange-500' : 'border-black-200'" 
                             style="z-index: 1">
                          <span class="color-black-900 text-sm2">{{root.name}}</span>
                        </div>
                      </div>
                      <divider [borderWidth]="'2px'" style="position: absolute; right: 0px; top: 0; height: 100%"></divider>
                    </div>
                   
                    <tree-component *ngIf="this.selectedLeftSideNode" 
                      (nodeSelected)="onNodeSelected($event)"
                      [isNodeExpandable]="isNodeExpandable"
                      [getChildrenDep]="getNodeChildren.bind(this)"
                      [searchChildrenDep]="searchTreeNodes.bind(this)"
                    >
                    </tree-component>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div *ngIf="flag" class="card-body">
          <hr/>
          <h5 class="pl-3 pb-3">Custom CIC/TIC params</h5>
          <div class="row pl-3 pr-3" style="column-gap: 1rem; display: flex">
            <mat-form-field  appearance="outline" class="sp-form-field" style="width: 32%">
              <mat-label class="sp-input-label">Countries to launch</mat-label>
              <mat-icon class="sp-select-icon sp-dialog-icon" matPrefix svgIcon="icon_sp_world"></mat-icon>
              <mat-select (selectionChange)="onCicCountriesSelected($event.value)" [value]="cicCountriesSelected" placeholder="Select the countries" class="sp-input-content" multiple no-space>
                <mat-option *ngFor="let country of countryList" [value]="country">{{country.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field  appearance="outline" class="sp-form-field" style="width: 32%">
              <mat-label class="sp-input-label">Topics universe to launch</mat-label>
              <mat-icon class="sp-select-icon sp-dialog-icon" matPrefix svgIcon="icon_sp_world"></mat-icon>
              <mat-select (selectionChange)="onTopicUniverseSelected($event.value)" [value]="topicUniverseSelected" placeholder="Select the topic universe" class="sp-input-content" no-space>
                <mat-option>No selection</mat-option>
                <mat-option *ngFor="let topics of topicsList" [value]="topics">{{ topics.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field  appearance="outline" class="sp-form-field" style="width: 32%">
              <mat-label class="sp-input-label">Political universe to launch</mat-label>
              <mat-icon class="sp-select-icon sp-dialog-icon" matPrefix svgIcon="icon_sp_world"></mat-icon>
              <mat-select (selectionChange)="onPoliticalUniverseSelected($event.value)" [value]="politicalUniverseSelected" placeholder="Select the political universe" class="sp-input-content" no-space>
                <mat-option>No selection</mat-option>
                <mat-option *ngFor="let politics of politicsList" [value]="politics">{{ politics.name }}</mat-option>
              </mat-select>
            </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>